export default (value, [length]) => {
  if (value === undefined || value === null) {
    return false
  }

  return String(value).length >= length
}



// WEBPACK FOOTER //
// ./src/validator/min.js